<template>
  <div>
    <GalleryPortfolio class="gallery"/>
  </div>
</template>

<script>
import GalleryPortfolio from "../components/GalleryPortfolio.vue"
export default {
  name: "Portfolio",
  components: {
    GalleryPortfolio,
  }
};
</script>

<style scoped>

</style>